module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_08-879c260d7d81a50315bf1350bd3981a0.png";